export default __webpack_public_path__ + "static/media/ACOUSTIC.d7092300.mp4";